import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface IStockCountDetail_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IStockCountDetail_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  ReadFromLocalStorage: string;
  ReadFromLocalStorage_dummy: string;
  GetItem: any[];
  GetItem_dummy: any[];
  GetInventoryCountLineByHeader: any[];
  GetInventoryCountLineByHeader_dummy: any[];
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  HS_InventoryCountLineInsertFromBarcode: any[];
  HS_InventoryCountLineInsertFromBarcode_dummy: any[];
  ScanBarcode: string;
  ScanBarcode_dummy: string;
  SetValueOf: any;
  SetValueOf_dummy: any;
  CountListForPost: any[];
  CountListForPost_dummy: any[];
  PostInventoryCount: any;
  PostInventoryCount_dummy: any;
  Notify: boolean;
  Notify_dummy: boolean;
  HS_DeleteCount: any[];
  HS_DeleteCount_dummy: any[];
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  isComp943807Visible: "visible" | "hidden";
  isComp37504Visible: "visible" | "hidden";
  isComp251937Visible: "visible" | "hidden";
  isComp576803Visible: "visible" | "hidden";
  isComp721759Visible: "visible" | "hidden";
  isComp402812Visible: "visible" | "hidden";
  isComp530942Visible: "visible" | "hidden";
  isComp531425Enabled: "enabled" | "disabled";
  isComp232139Enabled: "enabled" | "disabled";
  isComp491020Enabled: "enabled" | "disabled";
}

export class StockCountDetail_ScreenBase extends React.PureComponent<
  IStockCountDetail_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  stockcountdetail_576320_value_kuikaTableRef: React.RefObject<any>;
  stockcountdetail_196727_value_kuikaPaginationRef: React.RefObject<any>;
  stockcountdetail_633835_value_kuikaTableRef: React.RefObject<any>;
  stockcountdetail_355611_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "81a7bfc5-b0bf-4c81-9fb2-62506d7c77bb",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 245868, PropertyName: "value", Value: "Sayım Fişi" },
        { Id: 943807, PropertyName: "tab", Value: "Satırlar" },
        { Id: 553760, PropertyName: "value", Value: "Çıkar/Ekle" },
        { Id: 821407, PropertyName: "value", Value: "Çıkar/Ekle" },
        { Id: 980938, PropertyName: "placeholder", Value: "15" },
        { Id: 656145, PropertyName: "placeholder", Value: "Barkod Giriniz..." },
        { Id: 263027, PropertyName: "value", Value: "Barkod" },
        { Id: 576803, PropertyName: "value", Value: "Barkod Bulunamadı" },
        {
          Id: 721759,
          PropertyName: "value",
          Value: "Henüz sayılmamış üründen çıkarma yapılamaz",
        },
        { Id: 402812, PropertyName: "value", Value: "Eklendi" },
        { Id: 530942, PropertyName: "value", Value: "Çıkartıldı" },
        { Id: 367813, PropertyName: "value", Value: "Kategori" },
        { Id: 358223, PropertyName: "value", Value: "Marka" },
        { Id: 166599, PropertyName: "value", Value: "Önceki Sayım" },
        { Id: 984815, PropertyName: "value", Value: "Yeni Sayım" },
        { Id: 669539, PropertyName: "value", Value: "İşlenen Sayım" },
        { Id: 117271, PropertyName: "value", Value: "Ürün Ara" },
        { Id: 70262, PropertyName: "value", Value: "Ürün Kodu" },
        { Id: 384749, PropertyName: "value", Value: "Ürün Adı" },
        { Id: 60849, PropertyName: "label", Value: "Ara" },
        { Id: 889049, PropertyName: "title", Value: "Title" },
        { Id: 314991, PropertyName: "value", Value: "[datafield:itemcode]" },
        {
          Id: 201767,
          PropertyName: "value",
          Value: "[datafield:itemdescription]",
        },
        { Id: 489492, PropertyName: "value", Value: "Kategori" },
        {
          Id: 589172,
          PropertyName: "value",
          Value: "[datafield:productatt01desc]",
        },
        { Id: 791468, PropertyName: "value", Value: "Marka" },
        {
          Id: 835366,
          PropertyName: "value",
          Value: "[datafield:productatt02desc]",
        },
        { Id: 594209, PropertyName: "tab", Value: "Sonuç" },
        { Id: 420851, PropertyName: "value", Value: "Ürün Kodu" },
        { Id: 406515, PropertyName: "value", Value: "Ürün Adı" },
        { Id: 645234, PropertyName: "label", Value: "Temizle" },
        { Id: 707056, PropertyName: "label", Value: "Ara" },
        { Id: 531425, PropertyName: "label", Value: "NebimV3'e Gönder" },
        { Id: 850099, PropertyName: "title", Value: "Title" },
        { Id: 877028, PropertyName: "value", Value: "[datafield:itemcode]" },
        {
          Id: 955429,
          PropertyName: "value",
          Value: "[datafield:itemdescription]",
        },
        {
          Id: 359503,
          PropertyName: "value",
          Value: "[datafield:productatt01desc]",
        },
        {
          Id: 500025,
          PropertyName: "value",
          Value: "[datafield:productatt02desc]",
        },
        { Id: 158720, PropertyName: "value", Value: "Adet" },
        { Id: 938055, PropertyName: "value", Value: "[datafield:countqty]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.stockcountdetail_656145_value_kuikaTextInputRef = React.createRef();
    this.stockcountdetail_550531_value_kuikaTextInputRef = React.createRef();
    this.stockcountdetail_22731_value_kuikaTextInputRef = React.createRef();
    this.stockcountdetail_576320_value_kuikaTableRef = React.createRef();
    this.stockcountdetail_196727_value_kuikaPaginationRef = React.createRef();
    this.stockcountdetail_120970_value_kuikaTextInputRef = React.createRef();
    this.stockcountdetail_817167_value_kuikaTextInputRef = React.createRef();
    this.stockcountdetail_633835_value_kuikaTableRef = React.createRef();
    this.stockcountdetail_355611_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      NAVIGATE: "",
      ReadFromLocalStorage: "",
      GetItem: [],
      GetInventoryCountLineByHeader: [],
      ChangeVisibilityOf: "",
      HS_InventoryCountLineInsertFromBarcode: [],
      ScanBarcode: "",
      SetValueOf: "",
      CountListForPost: [],
      PostInventoryCount: "",
      Notify: false,
      HS_DeleteCount: [],
      TriggerEvent: "",
      isComp943807Visible: "visible",
      isComp37504Visible: "hidden",
      isComp251937Visible: "hidden",
      isComp576803Visible: "hidden",
      isComp721759Visible: "hidden",
      isComp402812Visible: "hidden",
      isComp530942Visible: "hidden",
      isComp531425Enabled: "disabled",
      isComp232139Enabled: "disabled",
      isComp491020Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "stockcountdetail",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.StockCountDetailPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.StockCountDetailPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "stockcountdetail",
      "header2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "stockcountdetail",
      "header2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.StockCountDetailPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.StockCountDetailPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      stockcountdetail_135272_value: true,
      stockcountdetail_980938_value: 1,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  checkTabErrors = () => {
    document.querySelectorAll(".rc-tabs-tab").forEach((tab) => {
      (tab as HTMLElement).style.color = "";
    });

    const tabPanes = document.querySelectorAll(".rc-tabs-tabpane");
    const tabs = document.querySelectorAll(".rc-tabs-tab");

    tabPanes.forEach((tabPane, index) => {
      const uniquePaneId = `rc-tabs-tabpane-${index}`;
      if (!tabPane.hasAttribute("id")) {
        tabPane.setAttribute("id", uniquePaneId);
      }

      const uniqueTabId = `rc-tabs-tab-${index}`;
      if (tabs[index]) {
        if (!tabs[index].hasAttribute("id")) {
          tabs[index].setAttribute("id", uniqueTabId);
        }
        tabs[index].setAttribute("aria-controls", uniquePaneId);
      }
    });

    const errorElements = document.querySelectorAll(
      ".rc-tabs .ant-form-item-explain-error"
    );

    const tabsWithErrors = new Set<string>();

    errorElements.forEach((errorElement) => {
      const tabPane = errorElement.closest(".rc-tabs-tabpane");
      if (tabPane && tabPane.id) {
        tabsWithErrors.add(tabPane.id);
      }
    });

    tabsWithErrors.forEach((tabPaneId) => {
      const tab = document.querySelector(
        `.rc-tabs-tab[aria-controls="${tabPaneId}"]`
      );
      if (tab) {
        (tab as HTMLElement).style.color = "red";
      }
    });
  };

  StockCountDetailPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromLocalStorage =
      await ReactSystemFunctions.readFromLocalStorage(
        ReactSystemFunctions.convertToTypeByName("CountHeaderId", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.StockCountDetailPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  StockCountDetailPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      ItemCode_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ItemDescription_0: ReactSystemFunctions.convertToTypeByName(
        null,
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      InventoryCountHeaderId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      SearchItemCode_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      SearchItemDescription_1: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      PageNumber_1: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockCountDetail/StockCountDetailPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetItem = result?.data.getItem;

    stateVars.GetInventoryCountLineByHeader =
      result?.data.getInventoryCountLineByHeader;

    stateVars.isComp531425Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].statuCode
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].statuCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("Completed", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp232139Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].statuCode
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].statuCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("Completed", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp491020Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].statuCode
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].statuCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("Completed", "string")
      ) === true
        ? "enabled"
        : "disabled";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.StockCountDetailPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountDetailPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].erpDocumentNo
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].erpDocumentNo
            : null
        ),
        true
      )
    ) {
      stateVars.ChangeVisibilityOf =
        await ReactSystemFunctions.changeVisibilityOf(
          this,
          ReactSystemFunctions.convertToTypeByName(
            "isComp943807Visible",
            "string"
          ),
          ReactSystemFunctions.convertToTypeByName("hidden", "string")
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.StockCountDetailPageInit3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.StockCountDetailPageInit3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  StockCountDetailPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp37504Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
            ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].barcode
              : null
            : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? this.state.HS_InventoryCountLineInsertFromBarcode[0].barcode
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp251937Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
            ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].result
              : null
            : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? this.state.HS_InventoryCountLineInsertFromBarcode[0].result
            : null
        ),
        "SUCCESS"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp576803Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
            ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].result
              : null
            : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? this.state.HS_InventoryCountLineInsertFromBarcode[0].result
            : null
        ),
        "BARCODE_NOT_FOUND"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp721759Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
            ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].result
              : null
            : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? this.state.HS_InventoryCountLineInsertFromBarcode[0].result
            : null
        ),
        "LINE_NOT_FOUND"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp402812Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
            ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? stateVars.HS_InventoryCountLineInsertFromBarcode[0]
                  .operationType
              : null
            : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? this.state.HS_InventoryCountLineInsertFromBarcode[0].operationType
            : null
        ),
        "ADD"
      ) &&
        ReactSystemFunctions.isNotEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
              ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
                ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].result
                : null
              : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? this.state.HS_InventoryCountLineInsertFromBarcode[0].result
              : null
          ),
          "BARCODE_NOT_FOUND"
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp530942Visible =
      (ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
            ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].result
              : null
            : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? this.state.HS_InventoryCountLineInsertFromBarcode[0].result
            : null
        ),
        "LINE_NOT_FOUND"
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
              ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
                ? stateVars.HS_InventoryCountLineInsertFromBarcode[0]
                    .operationType
                : null
              : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? this.state.HS_InventoryCountLineInsertFromBarcode[0]
                  .operationType
              : null
          ),
          "REMOVE"
        )) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_576320 = stateVars.GetItem ?? this.state.GetItem;
    formVars.stockcountdetail_196727_total = ReactSystemFunctions.value(
      this,
      stateVars.GetItem !== undefined
        ? stateVars.GetItem?.length > 0
          ? stateVars.GetItem[0].totalRowCount
          : null
        : this.state.GetItem?.length > 0
        ? this.state.GetItem[0].totalRowCount
        : null
    );

    stateVars.isComp531425Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].statuCode
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].statuCode
            : null
        ),
        "Completed"
      ) === true
        ? "enabled"
        : "disabled";

    stateVars.dataSource_633835 =
      stateVars.GetInventoryCountLineByHeader ??
      this.state.GetInventoryCountLineByHeader;
    stateVars.isComp232139Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].statuCode
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].statuCode
            : null
        ),
        "Completed"
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp491020Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].statuCode
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].statuCode
            : null
        ),
        "Completed"
      ) === true
        ? "enabled"
        : "disabled";
    formVars.stockcountdetail_355611_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInventoryCountLineByHeader !== undefined
        ? stateVars.GetInventoryCountLineByHeader?.length > 0
          ? stateVars.GetInventoryCountLineByHeader[0].totalRowCount
          : null
        : this.state.GetInventoryCountLineByHeader?.length > 0
        ? this.state.GetInventoryCountLineByHeader[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  StockCountDetailComponent_430437_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountDetailComponent_407529_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "StockCountInfo",
      "InventoryCountID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "StockCountDetail",
      "StockCountInfo",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "515983",
      null,
      null,
      "true",
      "100vw",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountDetailComponent_656145_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Barcode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountdetail_656145_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      IsAdd_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountdetail_135272_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      CountQty_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountdetail_980938_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      InventoryCountHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockCountDetail/StockCountDetailComponent_656145_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.HS_InventoryCountLineInsertFromBarcode =
      result?.data.hS_InventoryCountLineInsertFromBarcode;
    formVars.stockcountdetail_251937_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
        ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].barcode
          : null
        : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
        ? this.state.HS_InventoryCountLineInsertFromBarcode[0].barcode
        : null
    );
    formVars.stockcountdetail_174934_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
        ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].itemCode
          : null
        : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
        ? this.state.HS_InventoryCountLineInsertFromBarcode[0].itemCode
        : null
    );
    formVars.stockcountdetail_650156_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
        ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].itemDescription
          : null
        : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
        ? this.state.HS_InventoryCountLineInsertFromBarcode[0].itemDescription
        : null
    );
    formVars.stockcountdetail_902974_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
        ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].productAtt01Desc
          : null
        : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
        ? this.state.HS_InventoryCountLineInsertFromBarcode[0].productAtt01Desc
        : null
    );
    formVars.stockcountdetail_869192_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
        ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].productAtt02Desc
          : null
        : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
        ? this.state.HS_InventoryCountLineInsertFromBarcode[0].productAtt02Desc
        : null
    );
    formVars.stockcountdetail_780854_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
        ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].previousQty
          : null
        : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
        ? this.state.HS_InventoryCountLineInsertFromBarcode[0].previousQty
        : null
    );
    formVars.stockcountdetail_626780_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
        ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].newQty
          : null
        : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
        ? this.state.HS_InventoryCountLineInsertFromBarcode[0].newQty
        : null
    );
    formVars.stockcountdetail_657165_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
        ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].appliedQty
          : null
        : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
        ? this.state.HS_InventoryCountLineInsertFromBarcode[0].appliedQty
        : null
    );
    stateVars.isComp37504Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
            ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].barcode
              : null
            : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? this.state.HS_InventoryCountLineInsertFromBarcode[0].barcode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp251937Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
            ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].result
              : null
            : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? this.state.HS_InventoryCountLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp576803Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
            ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].result
              : null
            : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? this.state.HS_InventoryCountLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("BARCODE_NOT_FOUND", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp721759Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
            ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].result
              : null
            : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? this.state.HS_InventoryCountLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("LINE_NOT_FOUND", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp402812Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
            ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? stateVars.HS_InventoryCountLineInsertFromBarcode[0]
                  .operationType
              : null
            : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? this.state.HS_InventoryCountLineInsertFromBarcode[0].operationType
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ADD", "string")
      ) &&
        ReactSystemFunctions.isNotEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
              ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
                ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].result
                : null
              : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? this.state.HS_InventoryCountLineInsertFromBarcode[0].result
              : null
          ),
          ReactSystemFunctions.convertToTypeByName(
            "BARCODE_NOT_FOUND",
            "string"
          )
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp530942Visible =
      (ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
            ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].result
              : null
            : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? this.state.HS_InventoryCountLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("LINE_NOT_FOUND", "string")
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
              ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
                ? stateVars.HS_InventoryCountLineInsertFromBarcode[0]
                    .operationType
                : null
              : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? this.state.HS_InventoryCountLineInsertFromBarcode[0]
                  .operationType
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("REMOVE", "string")
        )) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.StockCountDetailComponent_656145_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountDetailComponent_656145_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stockcountdetail_251937_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
        ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].barcode
          : null
        : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
        ? this.state.HS_InventoryCountLineInsertFromBarcode[0].barcode
        : null
    );

    formVars.stockcountdetail_174934_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
        ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].itemCode
          : null
        : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
        ? this.state.HS_InventoryCountLineInsertFromBarcode[0].itemCode
        : null
    );

    formVars.stockcountdetail_650156_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
        ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].itemDescription
          : null
        : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
        ? this.state.HS_InventoryCountLineInsertFromBarcode[0].itemDescription
        : null
    );

    formVars.stockcountdetail_902974_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
        ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].productAtt01Desc
          : null
        : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
        ? this.state.HS_InventoryCountLineInsertFromBarcode[0].productAtt01Desc
        : null
    );

    formVars.stockcountdetail_869192_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
        ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].productAtt02Desc
          : null
        : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
        ? this.state.HS_InventoryCountLineInsertFromBarcode[0].productAtt02Desc
        : null
    );

    formVars.stockcountdetail_780854_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
        ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].previousQty
          : null
        : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
        ? this.state.HS_InventoryCountLineInsertFromBarcode[0].previousQty
        : null
    );

    formVars.stockcountdetail_626780_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
        ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].newQty
          : null
        : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
        ? this.state.HS_InventoryCountLineInsertFromBarcode[0].newQty
        : null
    );

    formVars.stockcountdetail_657165_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
        ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].appliedQty
          : null
        : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
        ? this.state.HS_InventoryCountLineInsertFromBarcode[0].appliedQty
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountDetailComponent_131297_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ScanBarcode = await ReactSystemFunctions.scanBarcode();

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.StockCountDetailComponent_131297_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  StockCountDetailComponent_131297_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Barcode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ScanBarcode),
        "string"
      ),
      IsAdd_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountdetail_135272_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      CountQty_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountdetail_980938_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      InventoryCountHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
    };

    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(this, this.state.ScanBarcode),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "StockCountDetail/StockCountDetailComponent_131297_onClick1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.HS_InventoryCountLineInsertFromBarcode =
        result?.data.hS_InventoryCountLineInsertFromBarcode;
      formVars.stockcountdetail_251937_value = ReactSystemFunctions.toString(
        this,
        stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
          ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].barcode
            : null
          : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? this.state.HS_InventoryCountLineInsertFromBarcode[0].barcode
          : null
      );
      formVars.stockcountdetail_174934_value = ReactSystemFunctions.toString(
        this,
        stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
          ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].itemCode
            : null
          : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? this.state.HS_InventoryCountLineInsertFromBarcode[0].itemCode
          : null
      );
      formVars.stockcountdetail_650156_value = ReactSystemFunctions.toString(
        this,
        stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
          ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? stateVars.HS_InventoryCountLineInsertFromBarcode[0]
                .itemDescription
            : null
          : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? this.state.HS_InventoryCountLineInsertFromBarcode[0].itemDescription
          : null
      );
      formVars.stockcountdetail_902974_value = ReactSystemFunctions.toString(
        this,
        stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
          ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? stateVars.HS_InventoryCountLineInsertFromBarcode[0]
                .productAtt01Desc
            : null
          : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? this.state.HS_InventoryCountLineInsertFromBarcode[0]
              .productAtt01Desc
          : null
      );
      formVars.stockcountdetail_869192_value = ReactSystemFunctions.toString(
        this,
        stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
          ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? stateVars.HS_InventoryCountLineInsertFromBarcode[0]
                .productAtt02Desc
            : null
          : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? this.state.HS_InventoryCountLineInsertFromBarcode[0]
              .productAtt02Desc
          : null
      );
      formVars.stockcountdetail_780854_value = ReactSystemFunctions.toString(
        this,
        stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
          ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].previousQty
            : null
          : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? this.state.HS_InventoryCountLineInsertFromBarcode[0].previousQty
          : null
      );
      formVars.stockcountdetail_626780_value = ReactSystemFunctions.toString(
        this,
        stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
          ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].newQty
            : null
          : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? this.state.HS_InventoryCountLineInsertFromBarcode[0].newQty
          : null
      );
      formVars.stockcountdetail_657165_value = ReactSystemFunctions.toString(
        this,
        stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
          ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].appliedQty
            : null
          : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? this.state.HS_InventoryCountLineInsertFromBarcode[0].appliedQty
          : null
      );
      stateVars.isComp37504Visible =
        ReactSystemFunctions.isNotEmpty(
          ReactSystemFunctions.toString(
            this,
            stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
              ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
                ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].barcode
                : null
              : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? this.state.HS_InventoryCountLineInsertFromBarcode[0].barcode
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("True", "string")
        ) === true
          ? "visible"
          : "hidden";
      stateVars.isComp251937Visible =
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
              ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
                ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].result
                : null
              : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? this.state.HS_InventoryCountLineInsertFromBarcode[0].result
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
        ) === true
          ? "visible"
          : "hidden";
      stateVars.isComp576803Visible =
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
              ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
                ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].result
                : null
              : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? this.state.HS_InventoryCountLineInsertFromBarcode[0].result
              : null
          ),
          ReactSystemFunctions.convertToTypeByName(
            "BARCODE_NOT_FOUND",
            "string"
          )
        ) === true
          ? "visible"
          : "hidden";
      stateVars.isComp721759Visible =
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
              ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
                ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].result
                : null
              : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? this.state.HS_InventoryCountLineInsertFromBarcode[0].result
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("LINE_NOT_FOUND", "string")
        ) === true
          ? "visible"
          : "hidden";
      stateVars.isComp402812Visible =
        (ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
              ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
                ? stateVars.HS_InventoryCountLineInsertFromBarcode[0]
                    .operationType
                : null
              : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? this.state.HS_InventoryCountLineInsertFromBarcode[0]
                  .operationType
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("ADD", "string")
        ) &&
          ReactSystemFunctions.isNotEqualTo(
            ReactSystemFunctions.toString(
              this,
              stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
                ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
                  ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].result
                  : null
                : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
                ? this.state.HS_InventoryCountLineInsertFromBarcode[0].result
                : null
            ),
            ReactSystemFunctions.convertToTypeByName(
              "BARCODE_NOT_FOUND",
              "string"
            )
          )) === true
          ? "visible"
          : "hidden";
      stateVars.isComp530942Visible =
        (ReactSystemFunctions.isNotEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
              ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
                ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].result
                : null
              : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
              ? this.state.HS_InventoryCountLineInsertFromBarcode[0].result
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("LINE_NOT_FOUND", "string")
        ) &&
          ReactSystemFunctions.isEqualTo(
            ReactSystemFunctions.toString(
              this,
              stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
                ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
                  ? stateVars.HS_InventoryCountLineInsertFromBarcode[0]
                      .operationType
                  : null
                : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
                ? this.state.HS_InventoryCountLineInsertFromBarcode[0]
                    .operationType
                : null
            ),
            ReactSystemFunctions.convertToTypeByName("REMOVE", "string")
          )) === true
          ? "visible"
          : "hidden";
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountDetailComponent_131297_onClick2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountDetailComponent_131297_onClick2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountDetailComponent_131297_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(this, this.state.ScanBarcode),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      formVars.stockcountdetail_251937_value = ReactSystemFunctions.toString(
        this,
        stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
          ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].barcode
            : null
          : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? this.state.HS_InventoryCountLineInsertFromBarcode[0].barcode
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountDetailComponent_131297_onClick3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountDetailComponent_131297_onClick3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  StockCountDetailComponent_131297_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(this, this.state.ScanBarcode),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      formVars.stockcountdetail_174934_value = ReactSystemFunctions.toString(
        this,
        stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
          ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].itemCode
            : null
          : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? this.state.HS_InventoryCountLineInsertFromBarcode[0].itemCode
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountDetailComponent_131297_onClick4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountDetailComponent_131297_onClick4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  StockCountDetailComponent_131297_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(this, this.state.ScanBarcode),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      formVars.stockcountdetail_650156_value = ReactSystemFunctions.toString(
        this,
        stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
          ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? stateVars.HS_InventoryCountLineInsertFromBarcode[0]
                .itemDescription
            : null
          : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? this.state.HS_InventoryCountLineInsertFromBarcode[0].itemDescription
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountDetailComponent_131297_onClick5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountDetailComponent_131297_onClick5_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  StockCountDetailComponent_131297_onClick5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(this, this.state.ScanBarcode),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      formVars.stockcountdetail_902974_value = ReactSystemFunctions.toString(
        this,
        stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
          ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? stateVars.HS_InventoryCountLineInsertFromBarcode[0]
                .productAtt01Desc
            : null
          : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? this.state.HS_InventoryCountLineInsertFromBarcode[0]
              .productAtt01Desc
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountDetailComponent_131297_onClick6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountDetailComponent_131297_onClick6_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  StockCountDetailComponent_131297_onClick6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(this, this.state.ScanBarcode),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      formVars.stockcountdetail_869192_value = ReactSystemFunctions.toString(
        this,
        stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
          ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? stateVars.HS_InventoryCountLineInsertFromBarcode[0]
                .productAtt02Desc
            : null
          : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? this.state.HS_InventoryCountLineInsertFromBarcode[0]
              .productAtt02Desc
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountDetailComponent_131297_onClick7_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountDetailComponent_131297_onClick7_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  StockCountDetailComponent_131297_onClick7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(this, this.state.ScanBarcode),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      formVars.stockcountdetail_780854_value = ReactSystemFunctions.toString(
        this,
        stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
          ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].previousQty
            : null
          : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? this.state.HS_InventoryCountLineInsertFromBarcode[0].previousQty
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountDetailComponent_131297_onClick8_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountDetailComponent_131297_onClick8_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  StockCountDetailComponent_131297_onClick8_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(this, this.state.ScanBarcode),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      formVars.stockcountdetail_626780_value = ReactSystemFunctions.toString(
        this,
        stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
          ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].newQty
            : null
          : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? this.state.HS_InventoryCountLineInsertFromBarcode[0].newQty
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountDetailComponent_131297_onClick9_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountDetailComponent_131297_onClick9_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  StockCountDetailComponent_131297_onClick9_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(this, this.state.ScanBarcode),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      formVars.stockcountdetail_657165_value = ReactSystemFunctions.toString(
        this,
        stateVars.HS_InventoryCountLineInsertFromBarcode !== undefined
          ? stateVars.HS_InventoryCountLineInsertFromBarcode?.length > 0
            ? stateVars.HS_InventoryCountLineInsertFromBarcode[0].appliedQty
            : null
          : this.state.HS_InventoryCountLineInsertFromBarcode?.length > 0
          ? this.state.HS_InventoryCountLineInsertFromBarcode[0].appliedQty
          : null
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  StockCountDetailComponent_60849_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ItemCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountdetail_550531_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ItemDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountdetail_22731_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockCountDetail/StockCountDetailComponent_60849_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetItem = result?.data.getItem;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.StockCountDetailComponent_60849_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountDetailComponent_60849_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "stockcountdetail_196727_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_576320 = stateVars.GetItem ?? this.state.GetItem;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountDetailComponent_222296_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "StockAddManuelItemCountPop",
      "CountHeaderID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "StockAddManuelItemCountPop",
      "ItemID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "stockcountdetail_576320_value", "id"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "StockCountDetail",
      "StockAddManuelItemCountPop",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "990671",
      null,
      null,
      "true",
      "400px",
      "400px",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountDetailComponent_196727_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ItemCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountdetail_550531_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ItemDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountdetail_22731_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountdetail_196727_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockCountDetail/StockCountDetailComponent_196727_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetItem = result?.data.getItem;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.StockCountDetailComponent_196727_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountDetailComponent_196727_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_576320 = stateVars.GetItem ?? this.state.GetItem;
    formVars.stockcountdetail_196727_total = ReactSystemFunctions.value(
      this,
      stateVars.GetItem !== undefined
        ? stateVars.GetItem?.length > 0
          ? stateVars.GetItem[0].totalRowCount
          : null
        : this.state.GetItem?.length > 0
        ? this.state.GetItem[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountDetailComponent_594209_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      InventoryCountHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      SearchItemCode_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      SearchItemDescription_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockCountDetail/StockCountDetailComponent_594209_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInventoryCountLineByHeader =
      result?.data.getInventoryCountLineByHeader;

    stateVars.isComp531425Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].statuCode
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].statuCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("Completed", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp232139Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].statuCode
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].statuCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("Completed", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp491020Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].statuCode
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].statuCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("Completed", "string")
      ) === true
        ? "enabled"
        : "disabled";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.StockCountDetailComponent_594209_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountDetailComponent_594209_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "stockcountdetail_355611_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "stockcountdetail_120970_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "stockcountdetail_817167_value",
        "string"
      ),
      "",
      null,
      false
    );

    stateVars.dataSource_633835 =
      stateVars.GetInventoryCountLineByHeader ??
      this.state.GetInventoryCountLineByHeader;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountDetailComponent_645234_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "stockcountdetail_355611_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "stockcountdetail_120970_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "stockcountdetail_817167_value",
        "string"
      ),
      "",
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.StockCountDetailComponent_645234_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  StockCountDetailComponent_645234_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      InventoryCountHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      SearchItemCode_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      SearchItemDescription_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockCountDetail/StockCountDetailComponent_645234_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInventoryCountLineByHeader =
      result?.data.getInventoryCountLineByHeader;

    stateVars.isComp531425Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].statuCode
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].statuCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("Completed", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp232139Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].statuCode
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].statuCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("Completed", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp491020Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].statuCode
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].statuCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("Completed", "string")
      ) === true
        ? "enabled"
        : "disabled";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.StockCountDetailComponent_645234_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountDetailComponent_645234_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_633835 =
      stateVars.GetInventoryCountLineByHeader ??
      this.state.GetInventoryCountLineByHeader;
    formVars.stockcountdetail_355611_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInventoryCountLineByHeader !== undefined
        ? stateVars.GetInventoryCountLineByHeader?.length > 0
          ? stateVars.GetInventoryCountLineByHeader[0].totalRowCount
          : null
        : this.state.GetInventoryCountLineByHeader?.length > 0
        ? this.state.GetInventoryCountLineByHeader[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountDetailComponent_707056_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      InventoryCountHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      SearchItemCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountdetail_120970_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SearchItemDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountdetail_817167_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockCountDetail/StockCountDetailComponent_707056_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInventoryCountLineByHeader =
      result?.data.getInventoryCountLineByHeader;

    stateVars.isComp531425Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].statuCode
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].statuCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("Completed", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp232139Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].statuCode
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].statuCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("Completed", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp491020Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].statuCode
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].statuCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("Completed", "string")
      ) === true
        ? "enabled"
        : "disabled";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.StockCountDetailComponent_707056_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountDetailComponent_707056_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "stockcountdetail_355611_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_633835 =
      stateVars.GetInventoryCountLineByHeader ??
      this.state.GetInventoryCountLineByHeader;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountDetailComponent_531425_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      InventoryCountHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      inventoryCountId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      description_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CountListForPost !== undefined
            ? stateVars.CountListForPost?.length > 0
              ? stateVars.CountListForPost[0].inventoryCountDescription
              : null
            : this.state.CountListForPost?.length > 0
            ? this.state.CountListForPost[0].inventoryCountDescription
            : null
        ),
        "string"
      ),
      lines_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, stateVars.CountListForPost),
        "any[]"
      ),
      lines_ItemCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CountListForPost?.itemCode
        ),
        "string"
      ),
      lines_ColorCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CountListForPost?.colorCode
        ),
        "string"
      ),
      lines_ItemDim1Code_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CountListForPost?.itemDim1Code
        ),
        "string"
      ),
      lines_Quantity_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, stateVars.CountListForPost?.countQty),
        "number"
      ),
      officeCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CountListForPost !== undefined
            ? stateVars.CountListForPost?.length > 0
              ? stateVars.CountListForPost[0].officeCode
              : null
            : this.state.CountListForPost?.length > 0
            ? this.state.CountListForPost[0].officeCode
            : null
        ),
        "string"
      ),
      storeCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CountListForPost !== undefined
            ? stateVars.CountListForPost?.length > 0
              ? stateVars.CountListForPost[0].storeCode
              : null
            : this.state.CountListForPost?.length > 0
            ? this.state.CountListForPost[0].storeCode
            : null
        ),
        "string"
      ),
      warehouseCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CountListForPost !== undefined
            ? stateVars.CountListForPost?.length > 0
              ? stateVars.CountListForPost[0].warehouseCode
              : null
            : this.state.CountListForPost?.length > 0
            ? this.state.CountListForPost[0].warehouseCode
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockCountDetail/StockCountDetailComponent_531425_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CountListForPost = result?.data.countListForPost;
    stateVars.PostInventoryCount = result?.data.postInventoryCount;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.StockCountDetailComponent_531425_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountDetailComponent_531425_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        this.state.PostInventoryCount?.responseMessage
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.StockCountDetailComponent_531425_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  StockCountDetailComponent_531425_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.PostInventoryCount?.isSuccess
        ),
        "1"
      )
    ) {
      const __currentPath = (
        window.location.hash
          ? window.location.hash.replace(/^#/, "").split("?")[0]
          : window.location.pathname.split("?")[0]
      ).toLowerCase();
      if (__currentPath !== "/stockcountlist") {
        this.context.setMasterPageInitLoaded(false);
        this.context.setMasterPageRecurringLoaded(false);
        this.context.setShouldTriggerPageInit(true);
      }
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "StockCountDetail",
        "StockCountList",
        "",
        "currentPage",
        null,
        null,
        null,
        null,
        null,
        null,
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  StockCountDetailComponent_232139_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "StockCountDetailEdit",
      "SatirID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "stockcountdetail_633835_value", "id"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "StockCountDetail",
      "StockCountDetailEdit",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "615373",
      null,
      null,
      "true",
      "400px",
      "400px",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountDetailComponent_491020_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "stockcountdetail_633835_value", "id"),
        "Guid"
      ),
      InventoryCountHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "f3219906_ef5a_d77f_655d_092faf2b4726_confirmation",
        this.defaultML,
        "Sayım satırını silmek istediğinize emin misiniz?&nbsp;Bu işlem geri alınamaz."
      ),
      "poppins",
      "Confirmation",
      "confirmation",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "StockCountDetail/StockCountDetailComponent_491020_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.HS_DeleteCount = result?.data.hS_DeleteCount;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountDetailComponent_491020_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountDetailComponent_491020_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_DeleteCount !== undefined
          ? stateVars.HS_DeleteCount?.length > 0
            ? stateVars.HS_DeleteCount[0].message
            : null
          : this.state.HS_DeleteCount?.length > 0
          ? this.state.HS_DeleteCount[0].message
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    await this.StockCountDetailPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountDetailComponent_355611_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      InventoryCountHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      SearchItemCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountdetail_120970_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SearchItemDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountdetail_817167_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountdetail_355611_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockCountDetail/StockCountDetailComponent_355611_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInventoryCountLineByHeader =
      result?.data.getInventoryCountLineByHeader;

    stateVars.isComp531425Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].statuCode
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].statuCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("Completed", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp232139Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].statuCode
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].statuCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("Completed", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp491020Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetInventoryCountLineByHeader !== undefined
            ? stateVars.GetInventoryCountLineByHeader?.length > 0
              ? stateVars.GetInventoryCountLineByHeader[0].statuCode
              : null
            : this.state.GetInventoryCountLineByHeader?.length > 0
            ? this.state.GetInventoryCountLineByHeader[0].statuCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("Completed", "string")
      ) === true
        ? "enabled"
        : "disabled";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.StockCountDetailComponent_355611_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountDetailComponent_355611_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_633835 =
      stateVars.GetInventoryCountLineByHeader ??
      this.state.GetInventoryCountLineByHeader;
    formVars.stockcountdetail_355611_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInventoryCountLineByHeader !== undefined
        ? stateVars.GetInventoryCountLineByHeader?.length > 0
          ? stateVars.GetInventoryCountLineByHeader[0].totalRowCount
          : null
        : this.state.GetInventoryCountLineByHeader?.length > 0
        ? this.state.GetInventoryCountLineByHeader[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [515983, 990671, , 615373] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.StockCountDetailPageInit();
    }
  }
}
